import { Injectable } from "@angular/core";
import { Subject } from "rxjs";
import { PageLoaderState } from "./page-loader.state";
@Injectable()
export class PageLoaderService {
	private loaderSubject = new Subject<PageLoaderState>();
	loaderState$ = this.loaderSubject.asObservable();
	constructor() {}
	show() {
		this.loaderSubject.next(<PageLoaderState>{ show: true });
	}
	hide() {
		this.loaderSubject.next(<PageLoaderState>{ show: false });
	}
}
